/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type EmailCategory = (typeof EmailCategory)[keyof typeof EmailCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailCategory = {
  PracticeCommunications: 1,
  AppointmentReminders: 2,
  Invoicing: 3,
} as const;
